
/* eslint-disable @typescript-eslint/camelcase */
import { Options, Vue, prop } from "vue-class-component";

interface LeaderboardOptions {
  label: string;
  value: string;
}

class Props {
  modelValue = prop<LeaderboardOptions>({
    default: null,
    required: false
  });
  options = prop<LeaderboardOptions[]>({
    required: true
  });
}

@Options({
  emits: ["select", "update:modelValue"]
})
class CategoryLeaderboardFilter extends Vue.with(Props) {
  onSelectFilter(item: LeaderboardOptions) {
    this.$emit("update:modelValue", item);
    this.$emit("select", item);
  }

  maplabelIcon(item: LeaderboardOptions) {
    const data: any = {
      NATIONAL: "leaderboard-national-icon",
      AREA: "leaderboard-area-icon",
      NEW_POS: "leaderboard-newcomer-icon"
    };

    return data[item.value] ?? "leaderboard-newcomer-icon";
  }
}

export default CategoryLeaderboardFilter;
